import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const ChannelType = iotsUtils.fromList(constants.chat.channel.channelTypes);
